// @ts-nocheck
export const localeCodes =  [
  "nl",
  "en"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_45NL_46json_65db7168",
      load: () => import("#nuxt-i18n/65db7168" /* webpackChunkName: "locale_nl_45NL_46json_65db7168" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45US_46json_3f52f1cd",
      load: () => import("#nuxt-i18n/3f52f1cd" /* webpackChunkName: "locale_en_45US_46json_3f52f1cd" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    name: "Dutch",
    code: "nl",
    iso: "nl-NL",
    dir: "ltr",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL"
  },
  {
    name: "English",
    code: "en",
    iso: "en-US",
    dir: "ltr",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  }
]
/** client **/

/** client-end **/